// @ts-nocheck
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import loadVariantChildrenIfNeeded from "@store/Framework/Common/Utilities/loadVariantChildrenIfNeeded";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const RequestVariantChildrenFromApi = createChainHandler("RequestVariantChildrenFromApi", chain, props => {
    loadVariantChildrenIfNeeded(props, props.apiResult?.products);
});

addToChainAfter(chain, RequestDataFromApi, RequestVariantChildrenFromApi);
